import React, { useEffect, useState,useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Icons
import HomeIcon from "@mui/icons-material/Home";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import GuestLoginModal from "../.../../../../../Components/GuestLoginModal";
import { AuthContext } from "../../../AuthContext/AuthContext";
import "../../Lease Module/CustomBottomNav.css";

/* ---------------- NORMAL NAV ---------------- */
const normalNavItems = [
  { key: "home", icon: <HomeIcon />, route: "/dashboard", label: "Home" },
  { key: "list", icon: <FormatListBulletedIcon />, route: "/details", label: "List" },
  { key: "saves", icon: <FavoriteBorderIcon />, route: "/rent-saves", label: "Saves" },
  { key: "inbox", icon: <MailOutlineIcon />, route: "/inboxlist", label: "Inbox" },
];

/* ---------------- SPECIAL NAV ---------------- */
const specialNavItems = [
  {
    key: "home",
    icon: <HomeIcon />,
    route: "/dashboard",
    label: "Home",
  },
  {
    key: "list",
    icon: <FormatListBulletedIcon />,
    route: ["/details", "/postbank_detail"],
    label: "List",
  },
  {
    key: "services",
    icon: <CleaningServicesIcon />,
    route: "/home-service",
    label: <span className="services-label">Home Services</span>,
  },
  {
    key: "profile",
    icon: <AccountCircleIcon />,
    route: "/work-detail",
    label: "More",
  },
];

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const [currentKey, setCurrentKey] = useState("");
const { isGuest } = useContext(AuthContext);
const [showGuestModal, setShowGuestModal] = useState(false);

// Tabs restricted for guests
const guestRestrictedTabs = ["saves", "inbox"];
  /* --------- Pages where special nav should appear --------- */
  const specialPages = [
    "/postbank-card",
    "/Post_Bankcard_indetail"
  ];

  const isSpecialPage = specialPages.some((path) =>
    location.pathname.startsWith(path)
  );

  /* --------- Check if current path matches a route --------- */
  const isRouteActive = (itemRoute) => {
    if (Array.isArray(itemRoute)) {
      return itemRoute.some(route => location.pathname.startsWith(route));
    }
    return location.pathname.startsWith(itemRoute);
  };

  /* --------- Active tab logic --------- */
  useEffect(() => {
    const items = isSpecialPage ? specialNavItems : normalNavItems;

    const active = items.find((item) => {
      if (Array.isArray(item.route)) {
        return item.route.some(route => location.pathname.startsWith(route));
      }
      return location.pathname.startsWith(item.route);
    })?.key || items[0].key;

    setCurrentKey(active);
  }, [location.pathname, isSpecialPage]);

  /* --------- Indicator movement --------- */
  useEffect(() => {
    const current = navRef.current?.querySelector(
      `.nav-item[data-key="${currentKey}"]`
    );
    const indicator = navRef.current?.querySelector(".nav-indicator");

    if (current && indicator) {
      const { offsetLeft, offsetWidth } = current;
      indicator.style.left = `${offsetLeft + offsetWidth / 2 - 25}px`;
    }
  }, [currentKey, isSpecialPage]);

const handleNav = (item) => {
  // 🚫 Block guest access
  if (isGuest && guestRestrictedTabs.includes(item.key)) {
    setShowGuestModal(true);
    return;
  }

  setCurrentKey(item.key);

  // Handle array of routes
  if (Array.isArray(item.route)) {
    if (isSpecialPage) {
      navigate("/postbank_detail");
    } else {
      navigate("/details");
    }
  } else {
    navigate(item.route);
  }
};

  return (
    <div className="nav-wrapper">
      <div className="nav-bar" ref={navRef}>
        {/* ---------- NORMAL NAV ---------- */}
        {!isSpecialPage &&
          normalNavItems.map((item) => (
            <div
              key={item.key}
              data-key={item.key}
              className={`nav-item ${
                currentKey === item.key ? "nav-item-active" : ""
              }`}
              onClick={() => handleNav(item)}
            >
              {item.icon}
              <div className="nav-label">{item.label}</div>
            </div>
          ))}

        {/* ---------- SPECIAL NAV ---------- */}
        {isSpecialPage &&
          specialNavItems.map((item) => (
            <div
              key={item.key}
              data-key={item.key}
              className={`nav-item ${
                currentKey === item.key ? "nav-item-active" : ""
              }`}
              onClick={() => handleNav(item)}
            >
              {item.icon}
              <div className="nav-label">{item.label}</div>
            </div>
          ))}

        <div className="nav-indicator" />
      </div>

      <GuestLoginModal
  open={showGuestModal}
  onClose={() => setShowGuestModal(false)}
/>

    </div>
  );
};

export default BottomNavbar;